import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { AbsencePeriod } from './AbsencePeriod';

export interface AbsencePeriodStatRow {
  id: number;
  absence_period_id: number;
  statistic_code: string;
  label: string;
  value: number;
  seq: number;
  created_at: string;
}

export const AbsencePeriodStat: Entity<AbsencePeriodStatRow> = {
  id: 'AbsencePeriodStat',
  title: 'Absence Period Statistic',
  service: 'main',
  rowLabel: (row: AbsencePeriodStatRow) => `${row.label}: ${row.value}`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.absence_period_stat',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition:
        'absence_period_id IN ( SELECT id FROM public.absence_period WHERE institution_id = {adminInstitutionId})',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['seq', 'ASC']],
  fields: {
    id: {
      seq: 10,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    absence_period_id: {
      seq: 20,
      label: 'Absence Period',
      type: FieldType.Reference,
      refEntity: AbsencePeriod,
      mandatory: true,
      listColumn: true,
    },
    statistic_code: {
      seq: 30,
      label: 'Statistic Code',
      type: FieldType.Text,
      mandatory: true,
      description: 'Machine-readable code identifying the statistic (e.g., absence-reason-sickness)',
    },
    label: {
      seq: 40,
      label: 'Label',
      type: FieldType.Text,
      mandatory: true,
      listColumn: true,
      description: 'Human-readable label for the statistic',
    },
    value: {
      seq: 50,
      label: 'Value',
      type: FieldType.Decimal,
      mandatory: true,
      listColumn: true,
    },
    seq: {
      seq: 55,
      label: 'Seq',
      type: FieldType.Decimal,
      mandatory: true,
    },
    created_at: {
      seq: 60,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
